/** A lossless CSV envelope: each top-level object's value is JSON in one CSV cell. */
export function stateToCSV(state: Record<string, unknown>): string {
  const cell = (value: string) => `"${value.replaceAll('"', '""')}"`;
  return 'key,json\r\n' + Object.entries(state).map(([key, value]) => `${cell(key)},${cell(JSON.stringify(value))}`).join('\r\n');
}
export function stateFromCSV(text: string): Record<string, unknown> {
  if (text.length > 128000) throw new Error('invalid_state');
  const rows: string[][] = []; let row: string[] = []; let cell = ''; let quoted = false; let afterQuote = false;
  const flush = () => { row.push(cell); cell = ''; afterQuote = false; };
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (quoted) { if (char === '"' && text[i + 1] === '"') { cell += '"'; i++; } else if (char === '"') { quoted = false; afterQuote = true; } else cell += char; continue; }
    if (char === '"') { if (cell || afterQuote) throw new Error('invalid_state'); quoted = true; }
    else if (char === ',') flush();
    else if (char === '\n' || char === '\r') { if (char === '\r' && text[i + 1] === '\n') i++; flush(); rows.push(row); row = []; }
    else { if (afterQuote) throw new Error('invalid_state'); cell += char; }
  }
  if (quoted) throw new Error('invalid_state');
  if (cell || row.length || afterQuote) { flush(); rows.push(row); }
  if (rows.shift()?.join(',') !== 'key,json') throw new Error('invalid_state');
  const result: Record<string, unknown> = Object.create(null);
  for (const cells of rows) { if (cells.length !== 2 || !cells[0] || Object.hasOwn(result, cells[0])) throw new Error('invalid_state'); Object.defineProperty(result, cells[0], { value: JSON.parse(cells[1]), enumerable: true, writable: true }); }
  return result;
}
export function downloadText(content: string, filename: string, mediaType = 'text/plain') {
  const url = URL.createObjectURL(new Blob([content], { type: `${mediaType};charset=utf-8` }));
  const link = document.createElement('a'); link.href = url; link.download = filename;
  document.body.appendChild(link); link.click(); link.remove(); window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
